import i18next from "i18next"
import { catchError, getError, http } from "services/http"
import { Bike, ErrorFn, ErrorResponse } from "models"
import { UploadBikefleetResponse } from "../types/bikeFleetType"

export const getBikeFleet = async (
	params: string
): Promise<{ res: Partial<Array<Bike>> } & ErrorFn> => {
	const getBikeFleetError = (error: ErrorResponse) => {
		switch (error?.code) {
			case "NotAuthorizedException":
				return {
					code: error?.code,
					message: i18next.t("edit_error_NotAuthorizedException", { ns: "api" }),
				}
			case "FleetBikeNotFoundException":
				return {
					code: error?.code,
					message: i18next.t("edit_errorEntityNotFoundException", { ns: "api" }),
				}
			default:
				return { code: error?.code, message: i18next.t("global_error", { ns: "api" }) }
		}
	}
	const res = await http
		.get(`/obikeapi/account/get_bikes?operator=${params}`)
		.then((res) => res.data)
		.catch((e) => catchError(e))

	return {
		res: res as unknown as Partial<Array<Bike>>,
		getError: getError(res as unknown as ErrorResponse, getBikeFleetError),
	}
}

export const addStore = async (params: {
	operator: string
	is_fleet: boolean
}): Promise<{ res: { account_id: string; entity_id: string } } & ErrorFn> => {
	const getBikeFleetError = (error: ErrorResponse) => {
		switch (error?.code) {
			case "NotAuthorizedException":
				return {
					code: error?.code,
					message: i18next.t("edit_error_NotAuthorizedException", { ns: "api" }),
				}
			case "FleetBikeNotFoundException":
				return {
					code: error?.code,
					message: i18next.t("edit_errorEntityNotFoundException", { ns: "api" }),
				}
			case "OperatorAccountLinkException":
				return {
					code: error?.code,
					message: i18next.t("bikeFleet.form.error.allReadyBikeFleet", { ns: "bike" }),
				}
			default:
				return { code: error?.code, message: i18next.t("global_error", { ns: "api" }) }
		}
	}
	const res = await http
		.post("/obikeapi/entity/operator/account", {
			operator: params.operator,
			is_fleet: params.is_fleet,
		})
		.then((res) => res.data)
		.catch((e) => catchError(e))

	return {
		res: res as unknown as { account_id: string; entity_id: string },
		getError: getError(res as unknown as ErrorResponse, getBikeFleetError),
	}
}

export const updateBikeStatus = async ({
	operator,
	bikeId,
	bikeStatus,
	rowVersion,
}): Promise<{ res: UploadBikefleetResponse } & ErrorFn> => {
	const getBikeFleetError = (error: ErrorResponse) => {
		switch (error?.code) {
			case "NotAuthorizedException":
				return {
					code: error?.code,
					message: i18next.t("edit_error_NotAuthorizedException", { ns: "api" }),
				}
			case "FleetBikeNotFoundException":
				return {
					code: error?.code,
					message: i18next.t("edit_errorEntityNotFoundException", { ns: "api" }),
				}
			case "OperatorAccountLinkException":
				return {
					code: error?.code,
					message: i18next.t("bikeFleet.form.error.allReadyBikeFleet", { ns: "bike" }),
				}
			default:
				return { code: error?.code, message: i18next.t("global_error", { ns: "api" }) }
		}
	}

	const res = await http
		.put(`obikeapi/account/update_bike?operator=${operator}`, {
			bike_id: bikeId,
			bike_status: bikeStatus,
			row_version: rowVersion,
		})
		.then((res) => res.data)
		.catch((e) => catchError(e))

	return {
		res: res as unknown as any,
		getError: getError(res as unknown as ErrorResponse, getBikeFleetError),
	}
}
